/**
 * Main Header + Navigation — slide-out nav (body.sbnavopen), desktop link → open + filter groups.
 */
(function () {
  function clearNavGroupFilter() {
    document.querySelectorAll('.gd-nav-in__group--hidden').forEach(function (el) {
      el.classList.remove('gd-nav-in__group--hidden');
    });
  }

  function setActiveNavGroup(index) {
    var groups = document.querySelectorAll('.gd-nav-in__group');
    if (!groups.length) return;
    var indexStr = String(index);
    var hasMatch = false;
    Array.prototype.forEach.call(groups, function (group) {
      if (group.getAttribute('data-bg-nav-group') === indexStr) {
        hasMatch = true;
      }
    });
    if (!hasMatch) {
      clearNavGroupFilter();
      return;
    }
    Array.prototype.forEach.call(groups, function (group) {
      if (group.getAttribute('data-bg-nav-group') === indexStr) {
        group.classList.remove('gd-nav-in__group--hidden');
      } else {
        group.classList.add('gd-nav-in__group--hidden');
      }
    });
  }

  function closeNav() {
    document.body.classList.remove('sbnavopen');
    clearNavGroupFilter();
  }

  function openNav() {
    document.body.classList.add('sbnavopen');
  }

  function toggleNav() {
    if (document.body.classList.contains('sbnavopen')) {
      closeNav();
    } else {
      clearNavGroupFilter();
      openNav();
    }
  }

  function onDocumentClick(e) {
    var el = e.target;
    if (el.closest('.gd-close') || el.closest('.gd-nav-backdrop')) {
      closeNav();
      return;
    }
    if (el.closest('.bg-site-header__menu-open') || el.closest('[data-bg-header-menu-open]')) {
      e.preventDefault();
      toggleNav();
      return;
    }
    var navLink = el.closest('.bg-site-header__nav a.bg-site-header__link');
    if (navLink && navLink.hasAttribute('data-bg-nav-group')) {
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      setActiveNavGroup(navLink.getAttribute('data-bg-nav-group'));
      openNav();
    }
  }

  document.addEventListener('click', onDocumentClick);
})();
